import classnames from 'classnames/bind'
import Image from '@/components/common/Image'
import { isEmpty } from 'lodash-es'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from '@/redux/hooks'

// Libs
import handleCopyValue from '@/methods/handleCopyValue'

// Components
import Link from '@/components/common/Link'
import Icon from '@/assets/icons'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

function SimpleHeader() {
  const { t } = useTranslation()
  const memberData = useAppSelector((state) => state?.member?.memberData)

  const handleEmailClick = () => {
    handleCopyValue({ t, value: EXTERNAL_LINK.CORNEY_BARROW_CONTACT_EMAIL })
  }

  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        <Link url={EXTERNAL_LINK.CORNEY_BARROW_OFFICIAL_SITE} isOpen>
          <div className={cx('header-logo')}>
            <Image src={`/images/c&b-logo.png`} width={141} height={135} alt='Corney & Barrow' />
          </div>
        </Link>
        <div className={cx('header__right')}>
          {!isEmpty(memberData.refCode) && <div className={cx('header__code')}>ID: {memberData.refCode}</div>}
          <div className={cx('header__actions')}>
            <button type='button' className={cx('header__action')} onClick={handleEmailClick} aria-label='Email'>
              <span className={cx('header__action-icon')}>
                <Image src='/images/corney-barrow-header-email.png' width={24} height={24} alt='' />
              </span>
            </button>
            <a
              className={cx('header__action')}
              href={EXTERNAL_LINK.CORNEY_BARROW_INSTAGRAM}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='Instagram'
            >
              <span className={cx('header__action-icon', 'header__action-icon--instagram')}>
                <Icon.Instagram />
              </span>
            </a>
            <a
              className={cx('header__action')}
              href={EXTERNAL_LINK.CORNEY_BARROW_OFFICIAL_SITE}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='Corney & Barrow Hong Kong'
            >
              <span className={cx('header__action-icon')}>
                <Image src='/images/corney-barrow-header-home.png' width={24} height={24} alt='' />
              </span>
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}

export default SimpleHeader
